import { useStore } from '@gx-vuex'
import { transTime } from '@/utils/util'

export default function () {
  const audioPlayNum = ref(0)

  const store = useStore()

  const pointErrorFun = (error) => {
    store.point.audioError(error)
  }

  const start = () => {
    const _editor36 = document.querySelectorAll('.preview-audio-player')
    const coverAudioList = document.querySelectorAll('.preview-audio-player-cover')
    _editor36.forEach((item, _) => {
      const dataId = item.getAttribute('data-id')
      const item_audio: any = item.querySelector('[class^="audio-block"]')
      const audioStyleCurTime = item.querySelector('.audio-current')
      const audioStyleTotalTime = item.querySelector('.audio-durtion')
      item_audio.addEventListener('durationchange', () => {
        audioStyleTotalTime.innerHTML = transTime(item_audio.duration)
      })

      item_audio.addEventListener('timeupdate', () => {
        audioStyleCurTime.innerHTML = transTime(item_audio.currentTime)
      })

      const audioStylePlay: any = item.querySelector('.audio-play-icon')
      const audioStylePause: any = item.querySelector('.audio-pause-icon')

      item_audio.addEventListener('error', () => {
        pointErrorFun('audio url error')
      })

      item_audio.addEventListener('ended', () => {
        audioStyleCurTime.innerHTML = '00:00'
      })

      audioStylePlay.addEventListener('click', (_) => {
        if (item_audio) {
          audioPlayNum.value += 1

          store.global.articleAudioPlayStatus = true

          item_audio.play()
          audioStylePlay.style.display = 'none'
          audioStylePause.style.display = 'block'

          _editor36.forEach((el) => {
            const dataIds = el.getAttribute('data-id')
            if (dataIds != dataId) {
              const item_audios: any = el.querySelector('[class^="audio-block"]')
              if (item_audios) {
                const audioStylePlays: any = el.querySelector('.audio-play-icon')
                const audioStylePauses: any = el.querySelector('.audio-pause-icon')
                item_audios.pause()
                audioStylePlays.style.display = 'block'
                audioStylePauses.style.display = 'none'
              }
            }
          })
          coverAudioList.forEach((el) => {
            const item_audios: any = el.querySelector('[class^="audio-block"]')
            if (item_audios) {
              const audioStylePlays: any = el.querySelector('.audio-play-icon')
              const audioStylePauses: any = el.querySelector('.audio-pause-icon')
              item_audios.pause()
              audioStylePauses.style.display = 'none'
              audioStylePlays.style.display = 'block'
            }
          })
        }
      })
      audioStylePause.addEventListener('click', (_) => {
        if (item_audio) {
          store.global.articleAudioPlayStatus = false
          item_audio.pause()
          audioStylePause.style.display = 'none'
          audioStylePlay.style.display = 'block'
        }
      })
    })
    coverAudioList.forEach((item, _) => {
      const dataId = item.getAttribute('data-id')
      const item_audio: any = item.querySelector('[class^="audio-block"]')
      const audioStyleCurTime = item.querySelector('.audio-current')
      const audioStyleTotalTime = item.querySelector('.audio-durtion')
      item_audio.addEventListener('durationchange', () => {
        audioStyleTotalTime.innerHTML = transTime(item_audio.duration)
      })

      item_audio.addEventListener('timeupdate', () => {
        audioStyleCurTime.innerHTML = transTime(item_audio.currentTime)
      })

      const audioStylePlay: any = item.querySelector('.audio-play-icon')
      const audioStylePause: any = item.querySelector('.audio-pause-icon')

      item_audio.addEventListener('ended', () => {
        audioStyleCurTime.innerHTML = '00:00'
      })

      item_audio.addEventListener('error', () => {
        pointErrorFun('audio url error')
      })

      audioStylePlay.addEventListener('click', (_) => {
        if (item_audio) {
          audioPlayNum.value += 1

          store.global.articleAudioPlayStatus = true

          item_audio.play()
          audioStylePlay.style.display = 'none'
          audioStylePause.style.display = 'block'

          _editor36.forEach((el) => {
            const item_audios: any = el.querySelector('[class^="audio-block"]')
            if (item_audios) {
              const audioStylePlays: any = el.querySelector('.audio-play-icon')
              const audioStylePauses: any = el.querySelector('.audio-pause-icon')
              item_audios.pause()
              audioStylePauses.style.display = 'none'
              audioStylePlays.style.display = 'block'
            }
          })
          coverAudioList.forEach((el) => {
            const dataIds = el.getAttribute('data-id')
            if (dataIds != dataId) {
              const item_audios: any = el.querySelector('[class^="audio-block"]')
              if (item_audios) {
                const audioStylePlays: any = el.querySelector('.audio-play-icon')
                const audioStylePauses: any = el.querySelector('.audio-pause-icon')
                item_audios.pause()
                audioStylePauses.style.display = 'none'
                audioStylePlays.style.display = 'block'
              }
            }
          })
        }
      })
      audioStylePause.addEventListener('click', (_) => {
        if (item_audio) {
          store.global.articleAudioPlayStatus = false
          item_audio.pause()
          audioStylePause.style.display = 'none'
          audioStylePlay.style.display = 'block'
        }
      })
    })
  }

  const remove = () => {
    const _editor36 = document.querySelectorAll('.preview-audio-player')
    const coverAudioList = document.querySelectorAll('.preview-audio-player-cover')

    _editor36.forEach((item, _) => {
      const item_audio = item.querySelector('[class^="audio-block"]')

      item_audio.removeEventListener('durationchange', () => {})
      item_audio.removeEventListener('timeupdate', () => {})
      item_audio.removeEventListener('ended', () => {})
      item_audio.removeEventListener('error', () => {})

      const audioStylePlay = item.querySelector('.audio-play-icon')
      const audioStylePause = item.querySelector('.audio-pause-icon')

      audioStylePlay.removeEventListener('click', (_) => {})
      audioStylePause.removeEventListener('click', (_) => {})
    })
    coverAudioList.forEach((item, _) => {
      const item_audio = item.querySelector('[class^="audio-block"]')

      item_audio.removeEventListener('durationchange', () => {})
      item_audio.removeEventListener('timeupdate', () => {})
      item_audio.removeEventListener('ended', () => {})
      item_audio.removeEventListener('error', () => {})

      const audioStylePlay = item.querySelector('.audio-play-icon')
      const audioStylePause = item.querySelector('.audio-pause-icon')

      audioStylePlay.removeEventListener('click', (_) => {})
      audioStylePause.removeEventListener('click', (_) => {})
    })
  }

  const pause = () => {
    const _editor36 = document.querySelectorAll('.preview-audio-player')
    const coverAudioList = document.querySelectorAll('.preview-audio-player-cover')
    _editor36.forEach((item, _) => {
      const dataId = item.getAttribute('data-id')
      const item_audio: any = item.querySelector('[class^="audio-block"]')

      const audioStylePlay: any = item.querySelector('.audio-play-icon')
      const audioStylePause: any = item.querySelector('.audio-pause-icon')

      if (item_audio) {
        store.global.articleAudioPlayStatus = false
        item_audio.pause()
        audioStylePause.style.display = 'none'
        audioStylePlay.style.display = 'block'
      }
    })
    coverAudioList.forEach((item, _) => {
      const dataId = item.getAttribute('data-id')
      const item_audio: any = item.querySelector('[class^="audio-block"]')

      const audioStylePlay: any = item.querySelector('.audio-play-icon')
      const audioStylePause: any = item.querySelector('.audio-pause-icon')

      if (item_audio) {
        item_audio.pause()
        audioStylePause.style.display = 'none'
        audioStylePlay.style.display = 'block'
      }
    })
  }

  return {
    start,
    pause,
    remove,
    audioPlayNum
  }
}
